<template>
    <div :class="['update-status-alert', $store.state.alertMessage.type]" @click.stop="onClick()">
        <div class="alert-message-container">
            <div class="info-icon">
                <Icon :icon-name="getInfoIcon" />
            </div>
            <div class="alert-message" v-html="$store.state.alertMessage.message" />
            <div class="button-container">
                <TertiaryButton dark-scheme v-if="hasThisMessage('global spacing')" text="Learn more" />
                <TertiaryButton dark-scheme v-if="hasThisMessage('Linked section')" :text="'Relink process step ' + $store.state.selectedNavStep + 1" />
                <TertiaryButton dark-scheme v-if="hasThisMessage('portfolio is live')" text="Manage domains" />
            </div>
            <div class="close-icon">
                <Icon icon-name="close"/>
            </div>
        </div>
    </div>
</template>

<script>
    import Cta from "./components/CtaButton.vue";
    import Icon from "../common/Icon.vue";
    import TertiaryButton from "@/scripts/common/components/TertiaryButton.vue";

    export default {
        name: 'alert-message',
        components: {
            TertiaryButton,
            Icon,
            Cta,
        },
        mounted() {
            if(this.$store.state.alertMessage.show) {
                setTimeout(() => {
                    this.hideAlert()
                }, 1000 * this.$store.state.alertMessage.interval);

            }
            this.$nextTick(() => {
                if (this.hasThisMessage('Linked section')) {
                    this.$store.commit('scrollToSection', {sectionId: this.$store.state.selectedSection?._id})
                }
            })
        },
        watch: {
            "$route"(to, from) {
                this.hideAlert();
            }
        },
        computed: {
            getInfoIcon() {
                if(this.$store.state.alertMessage.type === 'success') {
                    return 'check'
                }
                else {
                    return 'info'
                }
            }
        },
        methods: {
            onClick() {
                if(this.hasThisMessage('global spacing')) {
                    this.$store.commit('openSidePanel', {panelPath:'style/spacing'});
                }
                if(this.hasThisMessage('Linked section')) {
                    this.$store.state.activeModal = "UpdateProcessStepModal";
                }
                if(this.hasThisMessage('portfolio is live')) {
                    this.$store.commit('openSidePanel', {panelPath:'settings/domain-and-url'});
                }
                this.hideAlert()
            },
            hideAlert() {
                this.$store.commit("showAlertMessage", {show: false, message: null, interval: null})
            },
            hasThisMessage(msg) {
                return this.$store.state.alertMessage && this.$store.state.alertMessage.message && this.$store.state.alertMessage.message.includes(msg)
            },
        }
    }
</script>

<style lang="scss" scoped>
    .update-status-alert {
        position: fixed;
        top: 0;
        left: 50%;
        z-index: 107;
        transform: translate(-50%, 66px);
        min-height: 56px;
        max-width: 600px;
        padding: 16px;
        display: flex;
        flex-direction: column;
        background: var(--asphalt95);
        border: 1px solid var(--asphalt90);
        border-radius: 4px;
        transition-property: opacity, transform;
        transition-duration: 150ms;
        transition-timing-function: ease-in-out;
        transition-delay: unset;
        cursor: pointer;
        box-shadow: var(--shadow-light-small);

        &.success,
        &.payment {
            .info-icon {
                color: var(--success50);
            }
        }

        &.alert {
            .info-icon {
                color: var(--error50);
            }
        }

        &.narrow {
            position: absolute;
            top: 50%;
            transform: translate(-50%, -50%);
            padding: 7px 12px 7px 8px;
        }


        .info-icon {
            width: 24px;
            height: 24px;
            color: var(--asphalt10);
            svg {
                width: 24px;
                height: 24px;
            }
        }

        .close-icon {
            width: 20px;
            height: 20px;
            color: var(--asphalt40);
            svg {
                width: 20px;
                height: 20px;
            }
        }

        .alert-message-container {
            flex-direction: row;
            display: flex;
            align-items: center;
            gap: 12px;

            .bold {
                font: var(--editor-ui-b2-semibold);
            }

            .alert-message {
                color: var(--asphalt10);
                font: var(--editor-ui-b2-regular);
            }
        }

        .alert-button {
            width: 73px;
            height: 36px;
            border: none;
            background: transparent;
            font: var(--editor-ui-l-semibold);
            color: var(--asphalt80);
            text-transform: uppercase;
            cursor: pointer;
        }
        .link {
            font-weight: bold;
            cursor: pointer;
        }

        .ufo-cta {
            align-self: flex-start;
            margin-left: 36px;
            margin-top: 7.5px;
        }

    }

    // animation
    .update-status-alert {
        &.alert-enter-active,
        &.alert-leave-active {
            transform: translate(-50%, 66px);
        }
        &.alert-enter-from,
        &.alert-leave-to {
            transform: translate(-50%, 12px);
            opacity: 0;
        }
    }
</style>